export const INFORMATIONAL_RESPONSES_RANT = [100, 199];
export const SUCCESSFUL_RESPONSES_RANGE = [200, 299];
export const REDIRECTION_MESSAGES_RANGE = [300, 399];
export const CLIENT_ERROR_RESPONSES_RANGE = [400, 499];
export const SERVER_ERROR_RESPONSE_RANGE = [500, 599];
export const CLIENT_SERVER_ERROR_RESPONSE_RANGE = [400, 599];

export const TOO_MANY_REQUESTS = 429;
